<template>
  <div v-if="body_show" style="padding-bottom: 55px">
    <public-header :colors="'#fff'" :headimg="data.userdetail.headimgurl" :routArg="routArg"></public-header>
    <div class="course_listnew">
      <ul>
        <li v-for="(item,index) in course_list" :key="index" class="clearfix" :class="{listli_r: index==1 || index==3 || index==5,listli_rs: index == course_list.length - 1}">
          <div class="listnew_l" v-if="item.donestatus == 1">
            <div @click="to_details(item.cid,item.cpid)">
              <a class="item-img-bg">
                <img :src="item.lockimg" />
                <span class="ov">{{item.name}}</span>
              </a>
              <p v-if="data.project_type==1">已有{{item.count}}人试学</p>
              <p v-else>已有{{item.count}}人完成</p>
            </div>
          </div>
          <div class="listnew_l" v-else-if="item.donestatus == 0">
            <div @click="to_details(item.cid,item.cpid, index)">
              <a class="item-img-bg">
                <img :src="item.lockimg" />
                <span>{{item.name}}</span>
              </a>
              <p>报告完成截止时间：<span>{{item.latest_time}}</span></p>
              <p v-if="data.project_type==1" style="margin-top: 0;">已有{{item.count}}人试学</p>
              <p v-else style="margin-top: 0;">已有{{item.count}}人完成</p>
            </div>
          </div>
          <div class="listnew_l" v-else-if="item.donestatus == 2" @click="to_tost(item.cid,item.cpid,0)">
            <img :src="item.lockimg" />
            <h2>{{item.name}}</h2>
            <p v-if="!data.project_type==1">项目开始时间：<span>{{item.starttime}}</span></p>
          </div>
        </li>
      </ul>
    </div>
    <router-link v-if="data.alldoned == 1" :to="'/person_report_new?cid=' + cid" class="course_href course_hrefs">
      <img src="@a/result2.png" />
      <p style="color: #EB5032;">一键生成个人报告</p>
    </router-link>
    <a v-else class="course_href">
      <img src="@a/result1.png" />
      <p>一键生成个人报告</p>
    </a>
    <van-popup v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img src="@a/vpo_v.png" />
        <h3>报名后进入小组学习全部项目</h3>
        <div class="href_v" @click="signHandle">立即报名</div>
      </div>
    </van-popup>
    <!-- 公用音频底部 -->
    <public-foot-audio :footerShow="footer_show"></public-foot-audio>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <!-- 未关注弹窗 -->
    <van-popup :close-on-click-overlay="false" v-model="assistant_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">{{data.userdetail.name}}你好！您已成功报名{{data.courseName}}，为了不和组织失联，请关注下方二维码。</h3>
        <h4>识别或扫描二维码</h4>
        <img src="@a/carrer.png" />
        <h4>已关注的看官自动忽略</h4>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getproject,
  coursedetail
} from "@/api/course";
import {
  project_click_time
} from "@/api/course"
import {
  statistics
} from "@/api/public";
import {
  statistic_next
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
import {
  getStorage,
  setStorage
} from "@/utils/tools"

export default {
  data() {
      return {
        cid: null,
        data: {},
        body_show: false,
        course_list: [],
        click_cpid: "",
        assistant_show: false,
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        footer_show: true,
        routArg: {},
        assistant_show: false
      }
    },
    props: {
      pulldata: Object
    },
    methods: {
      pullData(data) {
        let querys = this.$route.query;
        this.cid = querys.cid;
        this.pdk = querys.pdk;
        this.aspx = querys.aspx;
        this.body_show = true;
        this.data = data;
        // 判断是否关注
        // if (!data.subscribe) {
        //   this.assistant_show = true;
        // }
        this.course_list = data.projects;
        if (querys.source) {
          this.routArg['source'] = querys.source;
        }
        if (querys.pdk) {
          this.routArg['pdk'] = querys.pdk;
        }
        if (querys.aspx) {
          this.routArg['aspx'] = querys.aspx;
        }
        // })
      },
      to_details(cid_, cpid_, index) {
        let showModul = index == 3 ? 'true' : 'false';
        //判断是否是试听
        if (this.data.project_type == 1) {
          project_click_time({
              cid: cid_,
              cpid: cpid_
            })
            .then((data) => {
              this.$router.push({
                path: '/project_details',
                query: {
                  'cid': cid_,
                  'cpid': cpid_,
                  'pdk': this.routArg.pdk,
                  'aspx': this.routArg.aspx,
                  'source': this.routArg.source,
                  'showModul': showModul
                }
              });
              // this.$router.push("project_details?cid=" + cid_ + "&cpid=" + cpid_ + showModul);
            });
        } else {
          this.$router.push({
            path: '/project_details',
            query: {
              'cid': cid_,
              'cpid': cpid_,
              'pdk': this.routArg.pdk,
              'aspx': this.routArg.aspx,
              'source': this.routArg.source,
              'showModul': showModul
            }
          });
        }

      },
      to_tost: function(cid_, cpid_, toggle_) {
        var self = this;
        if (self.data.project_type == 1) {
          if (toggle_ == 0) {
            project_click_time({
                cid: cid_,
                cpid: cpid_
              })
              .then((data) => {
                this.click_cpid = cpid_;
                this.assistant_show = true;
              });
          } else {
            this.assistant_show = false;
          }
        }

      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        sensors.track('applyCourse', {
          classification: this.data.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime,
          apply_page_url: location.href,
          apply_page_title: this.data.bigcoursename
        });
        // 神策统计--点击立即报名按钮
        let godPolicy = getStorage('godPolicy', 'godPolicy');
        let bool = true;
        if (!godPolicy || godPolicy.length == 0) {
          bool = false;
          coursedetail({ // 因为目前只有一个，当前页面也没有bid所以暂时写死
              bid: this.data.bid
            })
            .then((data) => {
              godPolicy = data;
              // 把神策数据存到本地缓存
              let go = {
                course_id: this.cid,
                classification: data.bigcoursename,
                course_name: data.coursename,
                course_discount_price: data.courseprice,
                course_original_price: data.originalprice,
                course_starttime: data.begintime
              };
              setStorage('godPolicy', 'godPolicy', go);
              this.godPolicyHandle(false, godPolicy);
            })
        } else {
          this.godPolicyHandle(true, godPolicy);
        }


        if (this.data.mobilestatus) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = this.data.need_verify || false;
          // 判断用户手机号是否已验证
          this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
          this.$refs.handle.show = true;

        } else {
          this.$refs.handle.pay()
        }
      },
      // 立即报名神策方法
      godPolicyHandle(bool, godPolicy) {
        // 判断缓存是否有数据，如果没有请求数据
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: '个人战略—商业价值重塑课-项目列表',
          classification: bool ? godPolicy.classification : godPolicy.bigcoursename,
          classification_id: 1, //bid
          course_id: this.$route.query.cid,
          course_name: bool ? godPolicy.course_name : godPolicy.coursename,
          course_discount_price: bool ? godPolicy.course_discount_price : godPolicy.courseprice,
          course_original_price: bool ? godPolicy.course_original_price : godPolicy.originalprice,
          course_starttime: bool ? godPolicy.course_starttime : godPolicy.begintime
        });
      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      statistic_() {
        statistic_next({
            cid: this.cid
          })
          .then();
      },
      onScroll() {
        window.onscroll = (ev) => {
          let t = document.documentElement.scrollTop || document.body.scrollTop;
          let w = 10;
          if (t > w) {
            this.footer_show = false;
          } else {
            this.footer_show = true;
          }
        }
      }
    },
    created() {
      this.pullData(this.pulldata);
      shareCon("course", this);
    },
    mounted() {
      this.onScroll()
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.course_listnew {
  background: url(../../../assets/list_bg.png) top center no-repeat;
  background-size: cover;
  width: 750px;
  height: auto;
  margin-top: changeRem(.6) + px;
  .item-img-bg {
    span {
      display: block;
      color: #333;
      font-size: changeRem(.64) + px;
      margin-top: changeRem(.1) + px;
    }
  }
  ul {
    li {
      background: url(../../../assets/list1.png) top no-repeat;
      background-size: cover;
      width: 750px;
      padding: 0 changeRem(1.8) + px;
      text-align: left;
      .listnew_l {
        float: left;
        img {
          width: changeRem(2.6) + px;
        }
        p {
          color: #666;
          font-size: changeRem(.48) + px;
          line-height: changeRem(.6) + px;
          margin-top: changeRem(.15) + px;
          span {
            color: #EB5032;
          }
        }
      }
    }
    li.listli_r {
      text-align: right;
      background-image: url(../../../assets/list2.png);
      .listnew_l {
        float: right;
      }
    }
    li.listli_rs {
      background: none;
    }
  }
}

.course_href {
  display: block;
  margin: 0 auto;
  width: changeRem(6) + px;
  text-align: center;
  margin-top: changeRem(1.2) + px;
  img {
    width: changeRem(3.6) + px;
    height: changeRem(3.6) + px;
  }
  p {
    color: #333;
    font-size: changeRem(.64) + px;
    line-height: changeRem(.85) + px;
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 100px 60px 100px;
    img {
      width: 430px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
    }
    .href_v {
      display: block;
      width: changeRem(7.7) + px;
      line-height: changeRem(1.6) + px;
      text-align: center;
      background-color: #EB5032;
      margin: 0 auto;
      font-size: changeRem(.68) + px;
      color: #FFFFFF;
      -webkit-border-radius: changeRem(.16) + px;
      border-radius: changeRem(.16) + px;
      margin-top: 100px
    }
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
</style>
